import React, { Component } from 'react';

import RatingStar from './RatingStar';
import ModalComment from '../modal/Comment';

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCommentModalShow: false,
    };
  }

  toggleModalComment = () => {
    this.setState((prevState) => ({
      isCommentModalShow: !prevState.isCommentModalShow,
    }));
  }

  render() {
    const { productID, productName, reviews } = this.props;
    const { isCommentModalShow } = this.state;
    return (
      <>
        <div className="col-12 col-md-9 col-lg-6">
          <a
            className="btn btn-third btn__third col-12 mb-3"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.toggleModalComment();
            }}
          >
            我要評價
          </a>
          { reviews?.map((comment, index) => (
            <div className="product__comment-wrapper mb-3" key={index}>
              <div id={`comment-meta-${index}`} className="product__comment-meta mb-1">
                <span>{comment.name}</span>
                <RatingStar stars={comment.star} />
                <span>{comment.date}</span>
              </div>
              <div id={`comment-content-${index}`} className="product__comment-content">
                {comment.dsr}
              </div>
            </div>
          ))}
        </div>
        { isCommentModalShow
          ? (
            <ModalComment
              {...this.props}
              isShow={isCommentModalShow}
              id={productID}
              handleModalShown={this.toggleModalComment}
              productName={productName}
            />
          )
          : '' }
      </>
    );
  }
}
export default Comment;
